var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cart"},[_c('div',{staticClass:"cart__inner"},[(_vm.hasItems)?_c('CartItems'):_c('CartEmpty'),_vm._v(" "),_c('CartFooter',{staticClass:"cart__controls"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }